import React, { useState } from 'react';
import '../styles/Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    form.submit();
    setFormData({ name: '', email: '', message: '' });
    setSuccessMessage('送信が成功しました！ありがとうございます！');
  };

  return (
    <div className="page-container">
      <section id="contact" className="contact">
        <h2 className="contact-title">お問い合わせ</h2>
        <div className="contact-container">
          <div className="contact-form">
            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}
            <form
              action="https://formspree.io/f/xvggpygk"
              method="POST"
              className="formspree-form"
              onSubmit={handleFormSubmit}
            >
              <div className="form-group">
                <label htmlFor="name">
                  お名前 <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">
                  メールアドレス <span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">
                  メッセージ <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? '送信中...' : '送信'}
              </button>
            </form>
          </div>
        </div>
      </section>
      <footer className="footer">
        <p>© 2025 yhooai, All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Contact;
